import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FileThumb } from 'components/misc'
import { apiDownloadFile } from 'helpers/decorators/api'
import getFileType from 'utils/getFileType'
import { parseAuthCode } from 'utils/authCode'
import { isValidAuthCode, refreshBlobAccess } from '../../../redux/modules/api/common'
import { connect } from 'react-redux'

@apiDownloadFile()
@connect(
  () => {},
  { isValidAuthCode, refreshBlobAccess }
)
class File extends PureComponent {
  static propTypes = {
    src: PropTypes.string,
    onDownloadFile: PropTypes.func,
    downloadedFile: PropTypes.string,
    files: PropTypes.object,
    user: PropTypes.object.isRequired,
    title: PropTypes.string,
    withAuthCode: PropTypes.bool,
    withAuthCodeFromUrl: PropTypes.bool,
    clickable: PropTypes.bool,
    isValidAuthCode: PropTypes.func.isRequired,
    refreshBlobAccess: PropTypes.func.isRequired
  }

  static defaultProps = {
    withAuthCode: false,
    withAuthCodeFromUrl: false
  }

  state = {
    downloadedFile: '',
    loading: false,
    isAuthCodeValid: false
  }

  async componentDidMount () {
    const { src, user, withAuthCode, withAuthCodeFromUrl } = this.props

    if (!this.handleIsPublic(src) && !withAuthCode) {
      this.props.onDownloadFile(this.props.src)
    }

    const blobAccessAuthorizationCode = get(user, 'blobAccessAuthorizationCode')
    withAuthCode && blobAccessAuthorizationCode && await this.refreshBlobAccess(blobAccessAuthorizationCode)
    withAuthCodeFromUrl && await this.refreshBlobAccess(parseAuthCode(this.props))
  }

  handleOpenFile = (fileUrl, type, file) => {
    const { title } = this.props

    const link = document.createElement('a')

    let fileName = title ? `${title}.${type}` : `${fileUrl}.${type}`

    if (get(file, 'name')) {
      fileName = `${file.name}.${type}`
    } else if (fileUrl) {
      const url = new URL(fileUrl)

      if (url) {
        const name = url.searchParams.get('name')

        if (name) {
          fileName = `${name}.${type}`
        }
      }
    }

    document.body.appendChild(link)
    link.download = fileName
    link.href = fileUrl

    link.click()
  }

  handleIsPublic = url => typeof url === 'string' && url.includes('/public')

  refreshBlobAccess = async authCode => {
    const { body: isValid } = await this.props.isValidAuthCode(authCode)
    if(!isValid.value){
      await this.props.refreshBlobAccess(authCode)
    }

    this.setState({ isAuthCodeValid: true })
  }


  render() {
    const {
      downloadedFile,
      files,
      src,
      clickable,
      withAuthCode,
      withAuthCodeFromUrl,
      user
    } = this.props

    const isAuthCodeValid= this.state.isAuthCodeValid
    const fileUrl = get(files[src], 'fileLocalUrl') || downloadedFile
    const type = get(files[src], 'type') || ''
    const loading = get(files[src], 'loading')

    let mySrc = src

    if (withAuthCodeFromUrl) {
      const authCode = parseAuthCode(this.props)

      if (authCode) {
        const authCodeParam = '&authorizationCode=' + authCode

        mySrc = src + authCodeParam
      }
    }

    if (!type && !withAuthCode) {
      return null
    }

    return (
      ((isAuthCodeValid && withAuthCode) || !withAuthCode) && <FileThumb
        file={files[src]}
        type={type || getFileType(src)}
        fileUrl={fileUrl || mySrc}
        onClick={this.handleOpenFile}
        clickable={clickable}
        loading={loading}
        src={mySrc}
        blobAuthCode={withAuthCode && get(user, 'blobAccessAuthorizationCode')}
        isPublic={this.handleIsPublic(src)}
      />
    )
  }
}

export default File
